import theme from '../../../../../lib/theme';

const {
  layouts,
  scale,
  media
} = theme;

export default () => ({
  container: {
    ...layouts.column,

    alignItems: 'center',
    padding: `0 ${scale.xs}`,

    [media.s.up]: {
      padding: `0 ${scale.s}`,
    },
  },

  columns: {
    ...layouts.column,

    '& > *': {
      marginBottom: scale.m,
    },

    '& > *:last-child': {
      marginBottom: 0,
    },

    [media.l.up]: {
      ...layouts.row,

      alignItems: 'stretch',

      '& > *': {
        marginBottom: 0,
        marginRight: scale.m,
      },

      '& > *:last-child': {
        marginRight: 0,
      },
    },
  },
});
